import React, { Component } from "react";
import { defaultTemplate } from "core/hoc";
import PropTypes from "prop-types";
import { PageLayout, Content } from "core/layouts";
import { DispensingOrderWoundItemTemplate } from "../components";
import { BaasicButton } from "core/components";

class DispensingOrderReviewTemplate extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { dispensingOrderReviewViewStore } = this.props;
        const {
            contentLoading,
            wounds,
            goBack,
            isSummaryAvailable,
            proceedToSummary
        } = dispensingOrderReviewViewStore;

        return (
            <PageLayout store={dispensingOrderReviewViewStore}>
                <Content loading={contentLoading}>
                    <div className="btn--progress-bar__wrapper">
                        <BaasicButton
                            label="Wound Details"
                            className="btn btn--progress-bar is-completed"
                            icon="u-icon u-icon--sml btn--progress-bar__icon"
                            onClick={() => goBack()}
                        />
                        <BaasicButton
                            label="Dispensing Order Review"
                            className="btn btn--progress-bar active"
                            icon="u-icon u-icon--sml btn--progress-bar__icon"
                        />
                        <BaasicButton
                            label="Summary"
                            className="btn btn--progress-bar"
                            icon="u-icon u-icon--sml btn--progress-bar__icon"
                        />
                    </div>
                    <div className="card card--facility">
                        <div className="card--facility__body">
                            {wounds.map((wound) => (
                                <DispensingOrderWoundItemTemplate
                                    key={wound.id}
                                    wound={wound}
                                    dispensingOrderReviewViewStore={
                                        dispensingOrderReviewViewStore
                                    }
                                />
                            ))}
                        </div>
                        <div className="card--facility__footer">
                            <div className="card--facility__footer--wrapper">
                                {isSummaryAvailable && (
                                    <BaasicButton
                                        className="btn btn--med btn--primary"
                                        label="Proceed To Summary"
                                        onClick={() => proceedToSummary()}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </Content>
            </PageLayout>
        );
    }
}

DispensingOrderReviewTemplate.propTypes = {
    dispensingOrderReviewViewStore: PropTypes.object.isRequired,
};

export default defaultTemplate(DispensingOrderReviewTemplate);
